import React, { Dispatch, ReactNode, createContext, useReducer } from 'react';

import * as types from './types';
import { COLOR_MODES } from '../../consts/constants';
import { getActiveBrandConfig } from '../../theme/brands';

type ThemeState = { theme: string; brand: ReturnType<typeof getActiveBrandConfig> };
type ThemeAction = { type: string; payload: Partial<ThemeState> };

const initialState: ThemeState = {
  theme: COLOR_MODES.LIGHT,
  brand: getActiveBrandConfig(),
};

const themeReducer = (state: ThemeState, action: ThemeAction): ThemeState => {
  switch (action.type) {
    case types.TOGGLE_THEME:
      return {
        ...state,
        ...action.payload,
      };
  }
  return initialState;
};

type ThemeContextType = [ThemeState | null, Dispatch<ThemeAction>];
export const ThemeContext = createContext<ThemeContextType>([
  initialState,
  () => initialState,
]);

const ThemeContextProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [themeState, themeDispatch] = useReducer(themeReducer, initialState);

  return (
    <ThemeContext.Provider value={[themeState, themeDispatch]}>
      {children}
    </ThemeContext.Provider>
  );
};

export default ThemeContextProvider;
